import { take, put } from 'redux-saga/effects';
import { routeActions } from 'redux-simple-router';

import { STORE_VISIT } from '../constants/actionTypes';

export function *redirectToEditVisitOnCreateVisit() {
    while(true) {
        yield take(STORE_VISIT.REQUEST);
        const {visit} = yield take(STORE_VISIT.SUCCESS);
        yield put(routeActions.push('/visits/' + visit.trac));
    }
}